import React from 'react'
import { EnvField } from 'support/fields'
import { WhenEnvValueMatches } from '@morningtrain/react-helpers'
import { useValue } from '@morningtrain/react-resources'

export default function InventoryDeliveryNoteItemFields () {
  const inventoryItemId = useValue('id')

  function generatePath (name) {
    return ['globals.inventory.order_items', inventoryItemId, name].join('.')
  }

  function generateName (name) {
    return ['items', inventoryItemId, name].join('.')
  }

  return (
    <WhenEnvValueMatches name={generatePath('received')}>
      <EnvField path={generatePath('received')} name={generateName('received')} />
    </WhenEnvValueMatches>
  )
}
